import { render, staticRenderFns } from "./groups.permissions.vue?vue&type=template&id=29fd13d8&"
import script from "./groups.permissions.vue?vue&type=script&lang=js&"
export * from "./groups.permissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports